import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
    Box, 
    Paper, 
    TextField, 
    Button, 
    Typography, 
    Alert,
    InputAdornment,
    IconButton
} from '@mui/material';
import { Visibility, VisibilityOff, Lock, Email } from '@mui/icons-material';
import { loginWithEmail } from '../../../services/authService';
import { COLORS } from '../../../assets/colors';

function AdminLogin() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        const result = await loginWithEmail(email, password);
        
        if (result.success) {
            navigate('/admin/dashboard');
        } else {
            setError('Credenciales inválidas. Por favor intenta de nuevo.');
        }
        
        setLoading(false);
    };

    return (
        <Box sx={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: `linear-gradient(135deg, ${COLORS.primary} 0%, rgba(30, 58, 95, 0.95) 100%)`,
            padding: '20px'
        }}>
            <Paper sx={{
                padding: { xs: 3, sm: 4, md: 5 },
                borderRadius: '20px',
                maxWidth: '450px',
                width: '100%',
                boxShadow: '0px 12px 40px rgba(0, 0, 0, 0.3)',
                border: `3px solid ${COLORS.secondary}`
            }}>
                <Box sx={{ textAlign: 'center', marginBottom: 4 }}>
                    <Typography variant="h4" sx={{
                        fontFamily: 'Quicksand',
                        fontWeight: 'bold',
                        color: COLORS.primary,
                        marginBottom: 1
                    }}>
                        Admin Panel
                    </Typography>
                    <Typography variant="h5" sx={{
                        fontFamily: 'Quicksand',
                        fontWeight: 'bold',
                        color: COLORS.secondary,
                        marginBottom: 2
                    }}>
                        El Rosal
                    </Typography>
                    <Typography variant="body2" sx={{
                        fontFamily: 'Quicksand',
                        color: '#666'
                    }}>
                        Inicia sesión para gestionar el contenido
                    </Typography>
                </Box>

                {error && (
                    <Alert severity="error" sx={{ marginBottom: 3, fontFamily: 'Quicksand' }}>
                        {error}
                    </Alert>
                )}

                <form onSubmit={handleSubmit}>
                    <TextField
                        fullWidth
                        label="Correo Electrónico"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        sx={{ marginBottom: 2 }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Email sx={{ color: COLORS.primary }} />
                                </InputAdornment>
                            ),
                            sx: { fontFamily: 'Quicksand' }
                        }}
                        InputLabelProps={{
                            sx: { fontFamily: 'Quicksand' }
                        }}
                    />

                    <TextField
                        fullWidth
                        label="Contraseña"
                        type={showPassword ? 'text' : 'password'}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        sx={{ marginBottom: 3 }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Lock sx={{ color: COLORS.primary }} />
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={() => setShowPassword(!showPassword)}
                                        edge="end"
                                    >
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                            sx: { fontFamily: 'Quicksand' }
                        }}
                        InputLabelProps={{
                            sx: { fontFamily: 'Quicksand' }
                        }}
                    />

                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        disabled={loading}
                        sx={{
                            background: `linear-gradient(135deg, ${COLORS.primary} 0%, rgba(30, 58, 95, 0.95) 100%)`,
                            color: 'white',
                            padding: '12px',
                            borderRadius: '30px',
                            fontFamily: 'Quicksand',
                            fontWeight: 'bold',
                            fontSize: '1rem',
                            textTransform: 'none',
                            boxShadow: `0 4px 12px rgba(30, 58, 95, 0.4)`,
                            '&:hover': {
                                background: `linear-gradient(135deg, rgba(30, 58, 95, 0.95) 0%, ${COLORS.primary} 100%)`,
                                boxShadow: `0 6px 16px rgba(30, 58, 95, 0.6)`,
                            },
                            '&:disabled': {
                                opacity: 0.6
                            }
                        }}
                    >
                        {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
                    </Button>
                </form>
            </Paper>
        </Box>
    );
}

export default AdminLogin;
